import React from 'react';
import DocsLink from '../../../common/custom/DocsLink';

const FacebookWidget = () => {
  return (
    <>
      <h5>
        <b>Facebook Widget</b>
      </h5>
      <p>
        The Facebook Widget allows you to easily embed any Facebook Page, group, comments, etc. in
        your web app.
      </p>
      <DocsLink link="https://www.youtube.com/results?search_query=drapcode+plugin" />
      <br />
    </>
  );
};

export default FacebookWidget;
